import { Injectable } from '@angular/core';
import { StageService } from './stage.service';

declare let THREE: any;
import { BuildFloorService } from './build-floor.service';
import { ComponentBase } from '../component-base';
import { SceneUtilsService } from './scene-utils.service';
import { RailingGenerationService } from './railing/services/railing-generation.service';
import { Select3dService } from './select-3d.service';
import { EventLogService, Actions } from './eventLog';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';

@Injectable()

export class Cut45AngleService extends ComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private railingGeneration: RailingGenerationService,
    private buildFloorSrvc: BuildFloorService,
    private select3dService: Select3dService,
    private eventLog: EventLogService
  ) {
    super();
    this.disable();
    this.select3dService.selectedTierSubject.subscribe(value => {
      if (this.isEnabled()) {
        this.removeSprites();
        this.drawSprites();
      }
    });
  }
  // spriteMap = new THREE.TextureLoader().load('../../assets/images/welcome_page/cut_angle_active.png');
  // spriteMaterial = new THREE.SpriteMaterial({ map: this.spriteMap, color: 0xffffff });
  sprites = [];
  loader = new THREE.TextureLoader();
  private raycaster: any = new THREE.Raycaster();

  drawSprites() {
    let floor = this.select3dService.getSelectedTier();
    var points = floor.userData.points;
    var cutPoints = [];
    var height = floor.getWorldPosition(new THREE.Vector3()).y;

    for (var i = 0; i < points.length; i++) {
      if (!points[i].superstructureType && !points[(i - 1) < 0 ? points.length - 1 : (i - 1)].superstructureType) {
        var A = i > 0 ? (i - 1) % points.length : points.length - 1;
        var B = i;
        var C = (i + 1) % points.length;
        var vector1 = new THREE.Vector2(points[A].x - points[B].x, points[A].y - points[B].y);
        var vector2 = new THREE.Vector2(points[C].x - points[B].x, points[C].y - points[B].y);
        var mult = vector1.x * vector2.x + vector1.y * vector2.y;
        if (mult <= 0.05 && mult >= -0.05) {
          cutPoints.push(i);
        }
      }
    }

    for (i = 0; i < cutPoints.length; i++) {
      var spriteMap = this.loader.load('../../assets/images/sprites/45_cut.png');

      var spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

      var sprite = new AutoScaleSprite(50, 50, spriteMaterial);
      sprite.userData.floorId = floor.id;
      sprite.userData.pointIndex = cutPoints[i];

      this.sprites.push(sprite);
      sprite.position.set(points[cutPoints[i]].x, height, points[cutPoints[i]].y);
      this.stage.add(sprite);
    }
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites = [];
  }

    disable() {
    this.removeSprites();
    super.disable();
  }


  mouseDown(e) {
    var p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    var intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      this.cut(intersection[0].object);
      this.removeSprites();
    }
  }

  cut(intersection) {
    var pointIndex = intersection.userData.pointIndex;
    var floor = this.select3dService.getSelectedTier();
    var points = floor.userData.points;
    const oldPoints = points.map(p => ({...p}));

    var A = pointIndex > 0 ? (pointIndex - 1) % points.length : points.length - 1;
    var B = pointIndex;
    var C = (pointIndex + 1) % points.length;
    var point = new THREE.Vector2(points[B].x, points[B].y);
    var vector1 = new THREE.Vector2(points[A].x - points[B].x, points[A].y - points[B].y);
    var vector2 = new THREE.Vector2(points[C].x - points[B].x, points[C].y - points[B].y);
    var cutLength = (vector1.length() < vector2.length()) ? vector1.length() / 3 : vector2.length() / 3;
    vector1.setLength(cutLength);
    vector2.setLength(cutLength);
    var pointA = point.clone();
    var pointB = point.clone();
    pointA.add(vector1);
    pointB.add(vector2);

    points.splice(pointIndex, 1, {x: pointA.x, y: pointA.y}, {x: pointB.x, y: pointB.y});

    this.removeSprites();
    this.drawSprites();

    this.eventLog.dispatch(new Actions.EditFloorShapeAction(oldPoints, points, intersection.userData.floorId));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cut45-angle.service.ts